import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./store";

const el = document.getElementById("root");
const root = createRoot(el as HTMLElement);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
